import MuiButton from "./MuiButton";
import MuiIconButton from "./MuiIconButton";
import MuiPaper from "./MuiPaper";
import MuiTableCell from "./MuiTableCell";
import MuiTableHead from "./MuiTableHead";
import MuiTypography from "./MuiTypography";
import MuiToolbar from "./MuiToolbar";
import MuiSelect from "./MuiSelect";
import MuiInput from "./MuiInput";
import MuiBreadcrumbs from "./MuiBreadcrumbs";

export default {
  MuiBreadcrumbs,
  MuiButton,
  MuiIconButton,
  MuiPaper,
  MuiTableCell,
  MuiTableHead,
  MuiTypography,
  MuiToolbar,
  MuiSelect,
  MuiInput,
};
